import { Accordion } from '@carvana/helios-layout/accordion';
import { Button } from '@carvana/helios-navigation/button';
import useAnalyticEvent, { PageName } from '../../../hooks/useAnalyticEvent';

import {
  Container,
  FAQAccordionWrapper,
  FAQButtonWrapper,
  FAQHeader,
  FAQSectionWrapper,
  SubText,
  TextContainer
} from './FAQ.styles';

import { FAQData } from './StructuredFAQ';

const FAQSection = () => {
  const { recordActionClicked, recordEventAndNavigate } = useAnalyticEvent();

  const handleViewAllFAQsClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.href = '/help/';
    recordEventAndNavigate(e, PageName.Marketing, 'View All FAQs');
  };

  return (
    <Container>
      <FAQSectionWrapper>
        <div>
          <TextContainer>
            <FAQHeader>We’re here to help</FAQHeader>
            <SubText>
              Have questions about tracking your car’s value? We’ve got you covered.
            </SubText>
          </TextContainer>
          <FAQButtonWrapper className="desktop-only" onClick={handleViewAllFAQsClick} href="/help/">
            <Button size="lg" variant="secondary">
              View All FAQs
            </Button>
          </FAQButtonWrapper>
        </div>
        <div>
          <FAQAccordionWrapper>
            {FAQData(false).map(({ q, a }) => (
              <Accordion
                key={q}
                onExpanded={() => recordActionClicked(PageName.Marketing, 'FAQ', { question: q })}
                title={q}
                expandedHeight="800px"
                questionFontSize="bodyMd"
              >
                <>
                  {a.map(item => (
                    <div key={item.toString()}>{item}</div>
                  ))}
                </>
              </Accordion>
            ))}
          </FAQAccordionWrapper>
          <FAQButtonWrapper onClick={handleViewAllFAQsClick} href="/help/">
            <Button size="lg" variant="secondary">
              View All FAQs
            </Button>
          </FAQButtonWrapper>
        </div>
      </FAQSectionWrapper>
    </Container>
  );
};

export default FAQSection;
